module.exports = __webpack_public_path__ + "img/T6-B-xs_3.aef79833.png";